<template>
    <el-container style="height:86vh;">
    <el-container>
        <el-main>
            <appMain />
        </el-main>
    </el-container>
    </el-container>
</template>

<script>
import appMain from './components/appMain'

export default {
    components: {
        appMain
    }

}
</script>